import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: register the service worker so Pins can be added to a home screen.
// Registered immediately (not on window "load") so PWABuilder/store crawlers
// detect it before their analysis pass times out.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then(async (reg) => {
      // Periodic Background Sync (installed PWAs only): refresh the cached shell daily
      if (!("periodicSync" in reg)) return;
      try {
        const status = await navigator.permissions.query({ name: "periodic-background-sync" });
        if (status.state === "granted") {
          await reg.periodicSync.register("pins-refresh-shell", { minInterval: 24 * 60 * 60 * 1000 });
        }
      } catch (e) {
        void e; // unsupported browser — shell still refreshes on normal navigation
      }
    })
    .catch(() => {});
}
